import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * On route change, scroll to top by default. If the URL has a hash, scroll the
 * matching element into view. This makes /#explorer and /#submit links work
 * naturally, and keeps deep-linked pages clean.
 */
export const ScrollToHash = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // give React time to render before scrolling
      const id = hash.replace("#", "");
      const t = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          window.scrollTo({ top: 0, behavior: "instant" });
        }
      }, 60);
      return () => clearTimeout(t);
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
};
